import request, { rawRequest, checkStatus, parseJSON } from "utils/request";
import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function generatePresignedUrl(data, headers, disableAuth) {
  return rawRequest(
    baseRequestURL + "v1/generate_presigned_url",
    {
      method: "POST",
      body: JSON.stringify({ ...data }),
      headers: headers
    },
    disableAuth
  )
    .then((response) => {
      return checkStatus(response, disableAuth);
    })
    .then((response) => {
      return response.text();
    })
    .then((response) => {
      return response;
    });
}

export function executePresignedUrl(url, data, method) {
  return request(
    url,
    {
      method: method ?? "POST",
      body: data ? JSON.stringify({ ...data }) : undefined
    },
    true,
    true,
    true
  ).then((response) => response);
}
